// import state from "sweetalert/typings/modules/state";
import { EMP_ATTENDANCE } from "../action_types";
const initialstate = {
  emp_id: '',
  date: '',
  data: {},
  in_out: {},
  today_att_time: {},
  In_time: '',
  month_att_time: '',
  week_att_time: '',
}
export const attendenace = (state = initialstate, { type, payload }) => {
  switch (type) {
    case EMP_ATTENDANCE: {
      return {
        ...state,
        data: payload
      };
    }
    case 'EMP_TODAT_ATTENDANCE_TIME': {
      return {
        ...state,
        today_att_time: payload?.today_time,
      };
    }

    case 'SET_EMP_PUNCH_TIME_IN': {
      return {
        ...state,
        In_time: payload,
      };
    }
    case 'SET_EMP_PUNCH_TIME_IN_MONTH': {
      return {
        ...state,
        month_att_time: payload?.response,
      }
    }
    case 'SET_EMP_PUNCH_TIME_IN_WEEK': {
      return {
        ...state,
        week_att_time: payload?.week_hrs,
      }
    }
    case 'SET_COMPANY_HOLIDAY': {
      return {
        ...state,
        company_holiday: payload?.holiday,
      };
    }

    default: {
      return state;
    }

  }
}